<!-- Wishlist -->
<div class="container mx-auto px-3 pb-9">
  <div class="flex items-center justify-between">
    <h2 class="text-xl font-bold">Wishlist</h2>
    <a class="text-sm text-gray-500" [routerLink]="['/product']"
      >View All Product</a
    >
  </div>

  <div class="mt-6 lg:block">
    <div class="grid grid-cols-2 gap-3 lg:grid-cols-5" *ngIf="!loading">
      <ng-container *ngFor="let product of wishListProduct.products">
        <fc-product-item [product]="product"></fc-product-item>
      </ng-container>
    </div>
  </div>

  <!-- skeleton -->
  <div class="grid grid-cols-2 gap-3 lg:grid-cols-5" *ngIf="loading">
    <div class="product-wishlist-loading" *ngFor="let item of [1, 2, 3, 4, 5]">
      <p-skeleton class="w-full" height="19rem"></p-skeleton>
    </div>
  </div>
</div>
